// extracted by mini-css-extract-plugin
export default {"imageWrapper":"eJ-z","twoColumnImage":"fJ-z"};